export { default } from './PurchasesTripsList';
